import classNames from 'classnames';
import React from 'react';

interface IProps {
    icon?: string,
    type: 'danger' | 'warning',
    message?: string,
    messageList?: Array<string>
}

export const AlertMessage = (props: IProps) => {
    
    let message = props.message || '';
    let messageList = props.messageList || [];

    //line breaks
    if (message && message.includes('\n')) {
        let splitList = message.split('\n');
        message = splitList.shift() || 'An error occurred';
        messageList.concat(splitList);
    }

    const icon = props.icon ?? 'exclamation-sign';
    let category = 'Error';
    switch (props.type) {
        case 'danger':
            category = 'Error';
            break;
        case 'warning':
            category = 'Warning';
            break;
    }

    let hasMessageList:boolean = (messageList != null && messageList?.length > 0);

    return (
        <div className={classNames("alert", `alert-${props.type}`)} role="alert">
            {!hasMessageList && message &&
                <>
                    <span className="sr-only">{category}:</span>&nbsp;{message ?? 'Please contact BEE123 Support'}
                    <br />
                </>
            }
            {(hasMessageList) &&
                messageList?.map((element, index) => {
                    return <React.Fragment key={index}>
                        <span className={`glyphicon glyphicon-${icon}`} aria-hidden="true"></span>
                        <span className="sr-only">{category}:</span> &nbsp;{element}<br />
                    </React.Fragment>
                })
            }

        </div>
    );
}